//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import {Dialog} from 'vant';

Vue.use(Dialog);
export default {
  name: "owner_family",
  data() {
    return {
      saving: false,
      member: {},
      content: '获取验证码',
      canClick: true,
      totalTime: 30
    }
  },
  methods: {
    onSave() {
      if (!this.member.name) {
        this.$toast('请输入姓名');
        return;
      }

      if (!this.member.invitationCode) {
        this.$toast('请输入邀请码');
        return;
      }

      if (!/^1[3456789]\d{9}$/.test(this.member.phoneNumber)) {
        this.$toast('手机号格式无效');
        return;
      }
      if (!/^\d{6}$/.test(this.member.code)) {
        this.$toast('请输入6位数字验证码');
        return;
      }
      this.member.loginProvider = "Weixin";
      this.saving = true;
      abp.ajax.post('/api/services/app/Member/MemberFamilyCert', this.member).then(res => {
        this.$toast("认证成功");
        this.$store.commit('app/setIsReload', true);
        this.$router.replace({name: 'user'});
      }).catch(error => {
        if (error.response.status === 500) {
          // console.log(error.response.data.error);
          var err = {};
          err = error.response.data.error;
          if (err.message === "邀请码不正确") {
            this.showContact('邀请码不正确')
          }
        }
      }).finally(() => {
        this.saving = false;
      });
    },
    countDown() {
      if (!this.canClick) return;
      this.canClick = false;
      this.content = this.totalTime + 's后重新发送';
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + 's后重新发送';
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = '重新发送验证码';
          this.totalTime = 30;
          this.canClick = true;
        }
      }, 1000)
    },
    getVerificationCode() {
      if (!/^1[3456789]\d{9}$/.test(this.member.phoneNumber)) {
        this.$toast('手机号格式无效');
        return;
      }
      this.countDown();
      abp.ajax.post('/api/services/app/Verification/SendVerificationCode', {address: this.member.phoneNumber}).then(res => {
        this.$toast.success('发送成功');
        this.countDown();
      }).finally(() => {

      })
    },
    showContact(tit) {
      Dialog.confirm({
        title: '邀请码不正确',
        message: '可拨打人工电话进行申诉',
        confirmButtonText: '立即申诉'
      }).then(() => {
        window.location.href = 'tel://400-012-7878'
      }).catch(() => {
      });
    }
  },
  created() {
  }
}
